"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVideoChannelStencil = exports.videoChannelStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.videoChannelStencilDefinition = {
    view: {
        label: 'Video channel',
        group: 'Collections',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'header-media',
                    'title',
                    'teaser',
                    'linear-stream',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'epg-title',
                            'uri-title',
                            'featured-media',
                            'featured-video',
                        ],
                    },
                    {
                        name: 'Settings',
                        items: ['search-terms', 'standalone'],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                subAreas: [
                    {
                        name: 'Configuration',
                        items: ['include-content-tagged-with'],
                    },
                    {
                        name: 'Tagging',
                        items: [
                            'disciplines',
                            'content-categories',
                            'tag-events',
                            'tag-event-series',
                            'tag-persons',
                        ],
                    },
                ],
            },
        ],
        previewConfiguration: { hasPagePreview: true },
    },
    content: {
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.disciplinesPropertyDefinition.name]: properties_1.disciplinesPropertyDefinition,
        [properties_1.epgTitlePropertyDefinition.name]: properties_1.epgTitlePropertyDefinition,
        [properties_1.featuredMediaPropertyDefinition.name]: properties_1.featuredMediaPropertyDefinition,
        [properties_1.featuredTitlePropertyDefinition.name]: properties_1.featuredTitlePropertyDefinition,
        [properties_1.featuredVideoPropertyDefinition.name]: properties_1.featuredVideoPropertyDefinition,
        [properties_1.headerMediaPropertyDefinition.name]: properties_1.headerMediaPropertyDefinition,
        [properties_1.includeContentTaggedWithPropertyDefinition.name]: properties_1.includeContentTaggedWithPropertyDefinition,
        [properties_1.linearStreamPropertyDefinition.name]: properties_1.linearStreamPropertyDefinition,
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.searchTermsPropertyDefinition.name]: properties_1.searchTermsPropertyDefinition,
        [properties_1.seoTitlePropertyDefinition.name]: properties_1.seoTitlePropertyDefinition,
        [properties_1.socialTitlePropertyDefinition.name]: properties_1.socialTitlePropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        [properties_1.tagEventSeriesPropertyDefinition.name]: properties_1.tagEventSeriesPropertyDefinition,
        [properties_1.tagEventsPropertyDefinition.name]: properties_1.tagEventsPropertyDefinition,
        [properties_1.tagPersonsPropertyDefinition.name]: properties_1.tagPersonsPropertyDefinition,
        [properties_1.teaserPropertyDefinition.name]: properties_1.teaserPropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
        [properties_1.uriTitlePropertyDefinition.name]: properties_1.uriTitlePropertyDefinition,
    },
    localizations: [],
    roles: ['taxonomy-manager'],
    spaces: [
        'brand-building-events',
        'media-partnerships',
        'racing-bulls',
        'rbtv',
        'rbtv_temporary',
        'redbull-racing',
    ],
    name: 'video-channel',
};
const isVideoChannelStencil = (stencil) => {
    return stencil.name === exports.videoChannelStencilDefinition.name;
};
exports.isVideoChannelStencil = isVideoChannelStencil;
//# sourceMappingURL=data:application/json;base64,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